exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=checkbox][data-v-7482c6f9]{visibility:hidden}input[type=checkbox]+label[data-v-7482c6f9]{display:block;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;user-select:none}input[type=checkbox]+label p[data-v-7482c6f9]:first-child{padding-left:1rem;margin-left:-1rem}.checkbox[data-v-7482c6f9]{border:1px solid #a0a0a0;border-radius:4px;width:20px;height:20px;background:#fff}a[data-v-7482c6f9]{color:#000!important}", ""]);

// exports
